import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'

const SelectStagione = () => {
  const availableStagioni = useSelector(
    state => state.selection.availableStagioni,
  )
  const selectedStagione = useSelector(
    state => state.selection.selectedStagione,
  )

  const { setSelectedStagione } = useSelectionSet()

  const value = availableStagioni?.includes(selectedStagione)
    ? selectedStagione
    : undefined

  return (
    <Grid size={{ xs: 12, md: 2 }}>
      <Select
        id='available-stagioni'
        label='Stagione'
        value={value}
        options={availableStagioni}
        disabled={!availableStagioni}
        onChange={setSelectedStagione}
      />
    </Grid>
  )
}

export default SelectStagione
